<div class="header">
	<div class="md-text-lg-medium">Notifications</div>
</div>

@if (loading()) {
	<lb-loader />
} @else {
	@if (notifications().length > 0) {
		<div class="notifications">
			<div class="content">
				@for (notification of notifications(); track $index) {
					<ng-container *ngComponentOutlet="notification.component; inputs: notification.inputs" />
				}
			</div>
		</div>
	} @else {
		<lb-no-data-message iconUrl="untitled-ui/communication/message-notification-circle">
			<span>Great news! You're all caught up and there are <strong>no new notifications</strong> right now.</span>
		</lb-no-data-message>
	}
}
